import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Collapse, Typography } from 'antd';
import React, { useState } from 'react';
import * as S from './DealRoomSection.styles';
import { PanelItem } from './ThirdPartyInsurance';

const { Title, Text } = Typography;
export const { Panel } = Collapse;

const InsuranceCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">{`ביטוח תביעות אישיות מכסה את חברי וחברות הוועד באופן אישי בתביעות בגין מקרי תאונה שהתרחשו כתוצאה מרשלנות של הוועד. 
בנוסף, הביטוח מכסה נזק פיננסי שאינו מוחשי כתוצאה מהחלטה של חברי הוועד.
הפיצוי האפשרי תלוי בגובה ההרחבה שנרכשה, החל מ- 500,000 ₪ ועד 7,500,000₪.`}</Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`במסגרת ביקורת כיסוי אש שנתית התברר שכנופיית גנבים פרצה וגנבה מהבניין את כל ציוד כיבוי אש שנמצא בכל קומה וקומה, נזק כולל של כ-פציעה של אדם כתוצאה מנפילה בשביל שבו נפער בור שלא תוקן יכולה להוביל לתביעה נגד הבניין או הוועד בתביעת צד ג', וגם נגד חברי וחברות הוועד באופן אישי.`}</S.ListItem>
          <S.ListItem>{`ירידת ערך של דירות בעקבות החלטת הוועד להתקין מסתור הגנה נגד יונים שמסתיר את הנוף עלולה גם היא להביא לתביעות אישיות נגד חברי וחברות הוועד.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const InsuranceNotCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">
          {`לפוליסה מספר החרגות, העיקריות בהן: תביעת דיבה, תביעות בגין אי השגת ביטוח הולם (מקרים בהם הוועד לא רכש ביטוח מבנה), דוחות כספיים שלא אושרו ע״י מנהל חשבונות מוסמך, חריגה מתקציב שלא אושרה ע״י הדיירים כחוק, ופגיעה בפרטיות.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`הפוליסה לא מכסה תביעות בגין סכסוכי שכנים, אי תשלום מיסי ועד וייצוג בתביעות של ״צו עשה״ (תביעות בהן בית המשפט מתבקש לחייב את הוועד לבצע פעולה כלשהי, לדוגמה: תביעת ״צו עשה״ בדרישה לבצע איטום לגג לפני הגעת החורף).`}</S.ListItem>
          <S.ListItem>{`ועד הבית פרסם בקבוצת ווטסאפ של הבניין סרטון של דייר בבניין שנקרעה לו שקית זבל בלובי ולא ניקה אחריו, הדייר תובע את ועד הבית בטענה ללשון הרע, ביטוח חברי ועד לא יכסה תביעה זו.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const FAQs: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <S.ListWrapper className="number">
          <S.ListItem>
            <S.ListTitle>{`מי יכול לתבוע את הוועד באופן אישי?`}</S.ListTitle>
            <S.ListContent>{`כל גורם יכול לתבוע את ועד הבית. התביעות הנפוצות ביותר נגד ועד הבית באופן אישי הן של דיירי הבניין.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`למה אני צריך לרכוש כיסוי לתביעות אישיות נגד חברי ועד אם רכשתי ביטוח צד ג'?`}</S.ListTitle>
            <S.ListContent>{`לא. ביטוח צד ג' מכסה את הבניין כנגד תביעות של אורחים ודיירים, אך אינו מכסה נזקים לרכוש המשותף. ניתן להשוות את ביטוח הבניין לביטוח רכב. מרבית האנשים מבטחים את רכבם בביטוח צד ג' וביטוח מקיף כדי שבמקרה של תאונה יהיה כיסוי כנגד תביעה משפטית מהנפגע (צד ג') ופיצוי עבור הנזק התאונתי שנגרם לרכב (מקיף).`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`החלטתי לא לרכוש ביטוח מבנה לבניין, פרצה שריפה מארון חשמל ונגרם נזק רב
לרכוש משותף, דיירי הבניין הגישו נגדי תביעה, האם אני מכוסה?`}</S.ListTitle>
            <S.ListContent>{`ביטוח צד ג' מטרתו להגן על הבניין מפני תביעה כאשר התובע טוען לרשלנות של הבניין. ביטוח חברי ועד מיועד להגן על ועד הבית באופן אישי מפני תביעה כאשר התובע טוען לרשלנות של חבר ועד הבית באופן אישי`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`האם ניתן לרכוש רק את ביטוח חברי הוועד?`}</S.ListTitle>
            <S.ListContent>{`לא. אי רכישת כיסוי ביטוחי אינה מכוסה במסגרת ההרחבה לביטוח חברי ועד ולכן החשיבות גם ברכישת ביטוח מבנה. אנו ממליצים לכל ועד לקיים אסיפת דיירים, לעלות את נושא הביטוח והאפשרויות שיש ולכתוב פרוטוקול עם החלטת הדיירים ובכך למנוע מקרה תביעה שכזה.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>
              {`אם אחד הדיירים תבע את ועד הבית בגלל הוצאת דיבה/לשון הרע, האם ועד הבית `}
              <br />
              {`מוגן על ידי חבות אישית לחברי הוועד?`}
            </S.ListTitle>
            <S.ListContent>{`לא, ביטוח חברי הוועד הוא הרחבה של ביטוח צד ג' ולכן, לא ניתן לרכוש רק את ביטוח חברי הוועד.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>
              {`תבעו אותי אישית בתור ועד הבית ואני רוצה להפעיל את הפוליסה, מי משלם את `}
              <br />
              {`ההשתתפות עצמית?`}
            </S.ListTitle>
            <S.ListContent>{`כשם שתשלום הפוליסה לבניין נעשה מקופת ועד הבית ככה גם לעניין השתתפות עצמית. דרישת השתתפות עצמית מטעם חברת הביטוח לא תהיה אישית לחבר ועד הבית אלא לבניין.`}</S.ListContent>
          </S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const panelItems: PanelItem[] = [
  {
    key: '1',
    title: 'מה הביטוח מכסה?',
    content: <InsuranceCover />,
  },
  {
    key: '2',
    title: 'מה הביטוח לא מכסה?',
    content: <InsuranceNotCover />,
  },
  {
    key: '3',
    title: 'שאלות ותשובות נפוצות',
    content: <FAQs />,
  },
];

export const PersonalClaimsForCommitteeMember: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string | string[]>();
  return (
    <S.Wrapper>
      <S.Header>
        <Title level={2} className="main-title font-24">
          {`תביעות אישיות נגד חברי ועד`}
        </Title>
        <Title level={2} className="main-title">{`למה צריך ביטוח תביעות אישיות נגד חברי וחברות הוועד?`}</Title>
        <Text className="sub-text">{`ביטוח חברי ועד הוא הרחבה של ביטוח צד ג', שמטרתו להגן על חברי ועד הבית באופן אישי במקרה של תביעה הקשורה לרשלנות לפי פקודת הנזיקין. בשנים האחרונות תובעים מצד ג' נוטים לכלול בתביעותיהם גם את חברי הוועד באופן אישי, בנוסף לוועד הבית עצמו ולחברת הניהול אם קיימת. למרות שחברי הוועד פועלים בהתנדבות, הם נושאים באחריות מתוקף תפקידם ולכן חשופים לתביעות אישיות.`}</Text>
      </S.Header>
      <S.IconCollapseWrapper>
        <S.IconCollapse accordion className="custom-collapse" activeKey={activeKey} onChange={setActiveKey}>
          {panelItems.map((item) => (
            <Panel
              key={item.key}
              showArrow={false}
              header={
                <S.PanelHeader>
                  <S.IconWrapper>
                    {activeKey === item.key ? (
                      <MinusOutlined className="plus-icon" />
                    ) : (
                      <PlusOutlined className="plus-icon" />
                    )}
                  </S.IconWrapper>
                  <Text strong className="header-text">
                    {item.title}
                  </Text>
                </S.PanelHeader>
              }
            >
              {item.content}
            </Panel>
          ))}
        </S.IconCollapse>
      </S.IconCollapseWrapper>
    </S.Wrapper>
  );
};
